import { takeLatest, debounce, takeLeading } from 'redux-saga/effects';

import * as actions from '../actions';
import { fetchData, postData, patchData, deleteData, putData } from './genericSagas';

export default function* rootSaga() {
  yield takeLatest(actions.USER_LOGIN, postData);
  yield takeLatest(actions.USER_REGISTER, postData);
  yield takeLatest(actions.USER_VERIFICATION, postData);
  yield takeLatest(actions.USER_VERIFICATION_REQUEST, postData);
  yield takeLatest(actions.GET_PROFILE, fetchData);
  yield takeLatest(actions.GET_COURSE_WISHLIST, fetchData);
  yield takeLatest(actions.UPDATE_PROFILE, putData);
  yield takeLatest(actions.CHANGE_USER_PASSWORD, putData);

  // Forgot Password
  yield takeLatest(actions.REQUEST_TOKEN, postData);
  yield takeLatest(actions.TOKEN_VALIDATION, postData);
  yield takeLatest(actions.RESET_PASSWORD, postData);

  // Refer
  yield takeLatest(actions.GET_REFER_DETAIL, fetchData);
  yield takeLatest(actions.GET_REFER_LIST, fetchData);
  // LearnSIC USers
  yield takeLatest(actions.ADD_USER, postData);
  yield takeLatest(actions.GET_USERS, fetchData);
  yield takeLatest(actions.SEARCH_USER, fetchData);
  yield takeLatest(actions.GET_USER_DETAIL, fetchData);
  yield takeLatest(actions.EDIT_USER, putData);
  yield takeLatest(actions.DELETE_USER, deleteData);

  // Job Experience
  yield takeLatest(actions.ADD_JOB_EXPERIENCE, postData);
  yield takeLatest(actions.EDIT_JOB_EXPERIENCE, putData);
  yield takeLatest(actions.DELETE_JOB_EXPERIENCE, deleteData);

  //Edit Tutor
  yield takeLatest(actions.EDIT_TUTOR, putData);

  // Tutor Education
  yield takeLatest(actions.ADD_EDUCATION, postData);
  yield takeLatest(actions.EDIT_EDUCATION, putData);
  yield takeLatest(actions.DELETE_EDUCATION, deleteData);

  yield takeLatest(actions.ADD_TUTOR_EDUCATION_INFO, postData);
  yield takeLatest(actions.EDIT_TUTOR_EDUCATION_INFO, putData);
  yield takeLatest(actions.DELETE_TUTOR_EDUCATION_INFO, deleteData);

  yield takeLatest(actions.ADD_TUTOR_EXPERIENCE_INFO, postData);
  yield takeLatest(actions.EDIT_TUTOR_EXPERIENCE_INFO, putData);
  yield takeLatest(actions.DELETE_TUTOR_EXPERIENCE_INFO, deleteData);

  // Tutor Request
  yield takeLatest(actions.ADD_REQUEST_COURSE_FORM, postData);

  // Tutor Detail page
  yield takeLatest(actions.GET_TUTOR_DETAIL, fetchData);

  // My Attempted Tests
  yield takeLatest(actions.GET_MY_ATTEMPTED_TESTS, fetchData);
  yield takeLatest(actions.ENROL_MOCK_TEST, postData);

  // Course Reviews
  yield takeLatest(actions.GET_COURSE_REVIEW, fetchData);
  yield takeLatest(actions.GET_COURSE_REVIEW_BY_PAGE, fetchData);
  yield takeLatest(actions.ADD_COURSE_REVIEW, postData);
  yield takeLatest(actions.EDIT_COURSE_REVIEW, putData);
  yield takeLatest(actions.DELETE_COURSE_REVIEW, deleteData);
  // Like and dislike course review
  yield takeLatest(actions.LIKE_COURSE_REVIEW, postData);
  yield takeLatest(actions.DISLIKE_COURSE_REVIEW, postData);

  // landing
  yield takeLatest(actions.GET_HOME, fetchData);
  yield takeLatest(actions.GET_HOME_SEARCH, fetchData);
  yield takeLatest(actions.GET_LANDING_FAQ, fetchData);
  yield takeLatest(actions.GET_INFO, fetchData);
  yield takeLatest(actions.GET_COMPANY_INFO, fetchData);
  yield takeLatest(actions.GET_BLOG, fetchData);
  yield takeLatest(actions.GET_BLOG_DETAIL, fetchData);
  yield takeLatest(actions.GET_BLOG_DETAIL_DASHBOARD, fetchData);
  yield takeLatest(actions.GET_COURSE_LIST, fetchData);
  yield takeLatest(actions.GET_COURSES_BY_PAGE, fetchData);
  yield takeLatest(actions.GET_COURSE_DETAIL, fetchData);
  yield takeLatest(actions.GET_COURSE_ENROL_DETAIL, fetchData);
  yield takeLatest(actions.ADD_COURSE_ENROL_CONTENT, postData);
  yield takeLatest(actions.GET_COURSE_VIDEO, fetchData);
  yield takeLatest(actions.GET_COURSE_CATEGORY_LIST, fetchData);
  yield takeLatest(actions.ADD_CONTACT, postData);

  // Course Material
  yield takeLatest(actions.GET_COURSE_MATERIAL, fetchData);
  yield takeLatest(actions.GET_COURSE_MATERIAL_BY_ID, fetchData);

  //courses
  yield takeLatest(actions.GET_COURSES, fetchData);
  yield takeLatest(actions.GET_COURSE_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_COURSE_TO_WISHLIST, postData);
  yield takeLatest(actions.ADD_COURSE, postData);
  yield takeLatest(actions.EDIT_COURSE, putData);
  yield takeLatest(actions.DELETE_COURSE, deleteData);

  // Notes Course landing
  yield takeLatest(actions.GET_NOTES, fetchData);
  yield takeLatest(actions.ADD_NOTES, postData);
  yield takeLatest(actions.EDIT_NOTES, putData);
  yield takeLatest(actions.DELETE_NOTES, deleteData);

  // Question Course Landing
  yield takeLatest(actions.GET_QUESTION_DOUBTS, fetchData);
  yield takeLatest(actions.GET_QUESTION_DOUBTS_BY_PAGE, fetchData);
  yield takeLatest(actions.GET_QUESTION_DOUBTS_DETAIL, fetchData);
  yield takeLatest(actions.GET_QUESTION_DOUBT_COMMENT, fetchData);
  yield takeLatest(actions.GET_QUESTION_DOUBT_COMMENT_BY_PAGE, fetchData);
  yield takeLatest(actions.ADD_QUESTION_DOUBTS, postData);
  yield takeLatest(actions.EDIT_QUESTION_DOUBTS, putData);
  yield takeLatest(actions.DELETE_QUESTION_DOUBTS, deleteData);
  yield takeLatest(actions.ADD_QUESTION_DOUBT_COMMENT, postData);
  yield takeLatest(actions.EDIT_QUESTION_DOUBT_COMMENT, putData);
  yield takeLatest(actions.DELETE_QUESTION_DOUBT_COMMENT, deleteData);
  yield takeLatest(actions.LIKE_COURSE_QUESTION, postData);
  yield takeLatest(actions.LIKE_QUESTION_DOUBT_COMMENT, postData);

  yield takeLatest(actions.GET_USER_DOUBTS, fetchData);

  //subjects
  yield takeLatest(actions.GET_SUBJECTS, fetchData);
  yield takeLatest(actions.GET_SUBJECT_BY_SLUG, fetchData);
  yield takeLatest(actions.GET_SUBJECTS_BY_PAGE, fetchData);
  yield takeLatest(actions.ADD_SUBJECT, postData);
  yield takeLatest(actions.EDIT_SUBJECT, putData);
  yield takeLatest(actions.COPY_SUBJECT_CONTENT, putData);
  yield takeLatest(actions.DELETE_SUBJECT, deleteData);

  //chapters
  yield takeLatest(actions.GET_CHAPTERS, fetchData);
  yield takeLatest(actions.GET_CHAPTER_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_CHAPTER, postData);
  yield takeLatest(actions.EDIT_CHAPTER, putData);
  yield takeLatest(actions.DELETE_CHAPTER, deleteData);

  //tests
  yield takeLatest(actions.GET_TESTS, fetchData);
  yield takeLatest(actions.ADD_TEST, postData);
  yield takeLatest(actions.EDIT_TEST, putData);
  yield takeLatest(actions.DELETE_TEST, deleteData);

  //content
  yield takeLatest(actions.GET_CONTENTS, fetchData);
  yield takeLatest(actions.GET_CONTENT_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_CONTENT, postData);
  yield takeLatest(actions.EDIT_CONTENT, putData);
  yield takeLatest(actions.DELETE_CONTENT, deleteData);
  yield takeLatest(actions.ADD_CONTENT_FILE, postData);
  yield takeLatest(actions.EDIT_CONTENT_FILE, putData);
  yield takeLatest(actions.DELETE_CONTENT_FILE, deleteData);

  //video
  yield takeLatest(actions.GET_VIDEO_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_VIDEO, postData);
  yield takeLatest(actions.ADD_COURSE_ENROLL, postData);
  yield takeLatest(actions.GET_COURSE_ENROLL, fetchData);

  // Admin Enrol Data
  yield takeLatest(actions.GET_COURSE_CLIENT, fetchData);
  yield takeLatest(actions.ADD_COURSE_CLIENTS, postData);
  yield takeLatest(actions.EDIT_COURSE_CLIENTS, putData);
  yield takeLatest(actions.GET_MOCK_TEST_CLIENT, fetchData);
  yield takeLatest(actions.GET_MOCK_TEST_LIST, fetchData);
  yield takeLatest(actions.GET_MOCK_TEST_BY_SLUG, fetchData);
  yield takeLatest(actions.UPDATE_TIME_MOCK_TEST, putData);
  // Admin get Users Reviews
  yield takeLatest(actions.GET_USER_REVIEWS, fetchData);

  // Related Course
  yield takeLatest(actions.GET_RELATED_COURSE, fetchData);

  //quiz
  yield takeLatest(actions.GET_QUIZ, fetchData);
  yield takeLatest(actions.GET_QUIZ_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_QUIZ, postData);
  yield takeLatest(actions.EDIT_QUIZ, putData);
  yield takeLatest(actions.DELETE_QUIZ, deleteData);

  //quiz question
  yield takeLatest(actions.GET_QUIZ_QUESTIONS, fetchData);
  yield takeLatest(actions.ADD_QUIZ_QUESTION, postData);
  yield takeLatest(actions.EDIT_QUIZ_QUESTION, putData);
  yield takeLatest(actions.DELETE_QUIZ_QUESTION, deleteData);

  //quiz answer
  yield takeLatest(actions.GET_QUIZ_ANSWERS, fetchData);
  yield takeLatest(actions.ADD_QUIZ_ANSWER, postData);
  yield takeLatest(actions.EDIT_QUIZ_ANSWER, putData);
  yield takeLatest(actions.DELETE_QUIZ_ANSWER, deleteData);

  //INFORMATION
  //company
  yield takeLatest(actions.GET_COMPANY, fetchData);
  yield takeLatest(actions.ADD_COMPANY, postData);
  yield takeLatest(actions.EDIT_COMPANY, putData);
  yield takeLatest(actions.DELETE_COMPANY, deleteData);

  //testimonials
  yield takeLatest(actions.GET_TESTIMONIALS, fetchData);
  yield takeLatest(actions.ADD_TESTIMONIAL, postData);
  yield takeLatest(actions.EDIT_TESTIMONIAL, putData);
  yield takeLatest(actions.DELETE_TESTIMONIAL, deleteData);

  //landing
  yield takeLatest(actions.GET_LANDING, fetchData);
  yield takeLatest(actions.ADD_LANDING, postData);
  yield takeLatest(actions.EDIT_LANDING, putData);
  yield takeLatest(actions.DELETE_LANDING, deleteData);

  //landing sections
  yield takeLatest(actions.GET_LANDING_SECTION, fetchData);
  yield takeLatest(actions.ADD_LANDING_SECTION, postData);
  yield takeLatest(actions.EDIT_LANDING_SECTION, putData);
  yield takeLatest(actions.DELETE_LANDING_SECTION, deleteData);

  //blogs
  yield takeLatest(actions.GET_BLOGS, fetchData);
  yield takeLatest(actions.GET_BLOG_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_BLOG, postData);
  yield takeLatest(actions.EDIT_BLOG, putData);
  yield takeLatest(actions.DELETE_BLOG, deleteData);

  //blog category
  yield takeLatest(actions.GET_BLOG_CATEGORY, fetchData);
  yield takeLatest(actions.ADD_BLOG_CATEGORY, postData);
  yield takeLatest(actions.EDIT_BLOG_CATEGORY, putData);
  yield takeLatest(actions.DELETE_BLOG_CATEGORY, deleteData);

  // FAQ
  yield takeLatest(actions.GET_FAQ, fetchData);
  yield takeLatest(actions.ADD_FAQ, postData);
  yield takeLatest(actions.EDIT_FAQ, putData);
  yield takeLatest(actions.DELETE_FAQ, deleteData);

  //terms and conditions
  yield takeLatest(actions.GET_TERMS_CONDITIONS, fetchData);
  yield takeLatest(actions.GET_TUTOR_TERMS_CONDITIONS, fetchData);
  yield takeLatest(actions.ADD_TERMS_CONDITIONS, postData);
  yield takeLatest(actions.EDIT_TERMS_CONDITIONS, putData);
  yield takeLatest(actions.DELETE_TERMS_CONDITIONS, deleteData);

  // yield takeLatest(actions.GET_QUESTION, fetchQuizData);
  yield takeLatest(actions.GET_QUESTION, fetchData);
  yield takeLatest(actions.GET_QUIZ_ANSWER_SHEET, fetchData);
  yield takeLatest(actions.GET_QUIZ_SUMMARY, fetchData);
  yield takeLatest(actions.ADD_QUIZ_ANSWER_SHEET, postData);

  //MODEL TEST
  yield takeLatest(actions.GET_MODEL_TESTS, fetchData);
  yield takeLatest(actions.GET_MODEL_TEST_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_MODEL_TEST, postData);
  yield takeLatest(actions.EDIT_MODEL_TEST, putData);
  yield takeLatest(actions.DELETE_MODEL_TEST, deleteData);
  yield takeLatest(actions.GET_MODEL_TEST_CLIENTS, fetchData);

  //model test sections
  yield takeLatest(actions.GET_MODEL_TEST_SECTIONS, fetchData);
  yield takeLatest(actions.GET_MODEL_SECTION_BY_ID, fetchData);
  yield takeLatest(actions.ADD_MODEL_TEST_SECTION, postData);
  yield takeLatest(actions.EDIT_MODEL_TEST_SECTION, putData);
  yield takeLatest(actions.DELETE_MODEL_TEST_SECTION, deleteData);

  //model test questions
  yield takeLatest(actions.GET_QUESTIONS, fetchData);
  yield takeLatest(actions.GET_MODEL_TEST_QUESTION_BY_ID, fetchData);
  yield takeLatest(actions.ADD_QUESTION, postData);
  yield takeLatest(actions.EDIT_QUESTION, putData);
  yield takeLatest(actions.DELETE_QUESTION, deleteData);

  //model test answers
  yield takeLatest(actions.GET_ANSWERS, fetchData);
  yield takeLatest(actions.ADD_ANSWER, postData);
  yield takeLatest(actions.EDIT_ANSWER, putData);
  yield takeLatest(actions.DELETE_ANSWER, deleteData);

  //model test group answers
  yield takeLatest(actions.GET_GROUP_ANSWERS, fetchData);
  yield takeLatest(actions.ADD_GROUP_ANSWER, postData);
  yield takeLatest(actions.EDIT_GROUP_ANSWER, putData);
  yield takeLatest(actions.DELETE_GROUP_ANSWER, deleteData);

  // Doubts
  yield takeLatest(actions.GET_DOUBT_POST, fetchData);
  yield takeLatest(actions.GET_DOUBT_POST_BY_PAGE, fetchData);
  yield takeLatest(actions.GET_DOUBT_DETAIL_POST, fetchData);
  yield takeLatest(actions.SEARCH_DOUBT_QUESTION, fetchData);

  yield takeLatest(actions.ADD_DOUBT_POST, postData);
  yield takeLatest(actions.ADD_DOUBT_POLL, postData);
  yield takeLatest(actions.VOTE_DOUBT_POLL, postData);
  yield takeLatest(actions.EDIT_DOUBT_POST, putData);
  yield takeLatest(actions.DELETE_DOUBT_POST, deleteData);

  yield takeLatest(actions.ADD_DOUBT_POST_LIKE, postData);
  yield takeLatest(actions.GET_DOUBT_COMMENT, fetchData);
  yield takeLatest(actions.GET_DOUBT_COMMENT_FOR_DETAIL_PAGE, fetchData);
  yield takeLatest(actions.GET_LATEST_COURSE, fetchData);
  yield takeLatest(actions.GET_DOUBT_TOPIC, fetchData);
  yield takeLatest(actions.ADD_DOUBT_TOPIC, postData);
  yield takeLatest(actions.ADD_DOUBT_COMMENT, postData);
  yield takeLatest(actions.EDIT_DOUBT_COMMENT, putData);
  yield takeLatest(actions.DELETE_DOUBT_COMMENT, deleteData);
  yield takeLatest(actions.REPORT_DOUBT_POST, postData);
  yield takeLatest(actions.REPORT_DOUBT_COMMENT, postData);

  // Top doubt topic
  yield takeLatest(actions.GET_TOP_TOPICS, fetchData);

  // Admin Dashboard
  yield takeLatest(actions.GET_POST_REPORTS, fetchData);
  yield takeLatest(actions.EDIT_POST_REPORTS, putData);
  yield takeLatest(actions.GET_COMMENT_REPORTS, fetchData);
  yield takeLatest(actions.EDIT_COMMENT_REPORTS, putData);
  yield takeLatest(actions.GET_POST_REQUESTS, fetchData);
  yield takeLatest(actions.EDIT_DOUBT_REQUESTS_ADMIN, putData);
  yield takeLatest(actions.EDIT_COMMENT_ADMIN, putData);
  yield takeLatest(actions.GET_REQUESTED_COURSE_INQUIRY, fetchData);
  yield takeLatest(actions.GET_CONTACT_INQUIRIES, fetchData);
  yield takeLatest(actions.EDIT_CONTACT_INQUIRIES, putData);

  // Advertisement
  yield takeLatest(actions.GET_ADVERTISEMENT_FOR_PAGE, fetchData);

  // CRUD Advertisement for Admin
  yield takeLatest(actions.GET_ADVERTISEMENT, fetchData);
  yield takeLatest(actions.ADD_ADVERTISEMENT, postData);
  yield takeLatest(actions.EDIT_ADVERTISEMENT, putData);
  yield takeLatest(actions.DELETE_ADVERTISEMENT, deleteData);

  // Notifications
  yield takeLatest(actions.GET_NOTIFICATIONS, fetchData);
  yield takeLatest(actions.GET_NOTIFICATIONS_BY_PAGE, fetchData);

  yield takeLatest(actions.READ_ALL_NOTIFICATIONS, postData);
  yield takeLatest(actions.READ_SINGLE_NOTIFICATION, postData);
  yield takeLatest(actions.SEND_NOTIFICATION_FOR_TUTOR_REVIEW, putData);

  //Admin dashboard
  yield takeLatest(actions.GET_ADMIN_DASHBOARD, fetchData);

  //USER PROFILE
  //basic info
  yield takeLatest(actions.GET_USER_BASIC_INFO, fetchData);
  yield takeLatest(actions.EDIT_USER_BASIC_INFO, putData);

  //social info
  yield takeLatest(actions.GET_USER_SOCIAL_INFO, fetchData);
  yield takeLatest(actions.EDIT_USER_SOCIAL_INFO, putData);

  //education
  yield takeLatest(actions.GET_USER_EDUCATION_INFO, fetchData);
  yield takeLatest(actions.ADD_USER_EDUCATION_INFO, postData);
  yield takeLatest(actions.EDIT_USER_EDUCATION_INFO, putData);
  yield takeLatest(actions.DELETE_USER_EDUCATION_INFO, deleteData);

  //experience
  yield takeLatest(actions.GET_USER_EXPERIENCE_INFO, fetchData);
  yield takeLatest(actions.ADD_USER_EXPERIENCE_INFO, postData);
  yield takeLatest(actions.EDIT_USER_EXPERIENCE_INFO, putData);
  yield takeLatest(actions.DELETE_USER_EXPERIENCE_INFO, deleteData);

  //SEO
  yield takeLatest(actions.GET_SEO, fetchData);
  yield takeLatest(actions.ADD_SEO, postData);
  yield takeLatest(actions.EDIT_SEO, putData);
  yield takeLatest(actions.DELETE_SEO, deleteData);

  //Office
  yield takeLatest(actions.GET_OFFICE, fetchData);
  yield takeLatest(actions.ADD_OFFICE, postData);
  yield takeLatest(actions.EDIT_OFFICE, putData);
  yield takeLatest(actions.DELETE_OFFICE, deleteData);

  //Social Media
  yield takeLatest(actions.GET_SOCIAL_MEDIA, fetchData);
  yield takeLatest(actions.ADD_SOCIAL_MEDIA, postData);
  yield takeLatest(actions.EDIT_SOCIAL_MEDIA, putData);
  yield takeLatest(actions.DELETE_SOCIAL_MEDIA, deleteData);

  //Role
  yield takeLatest(actions.GET_ROLES, fetchData);
  yield takeLatest(actions.GET_SINGLE_ROLE, fetchData);
  yield takeLatest(actions.ADD_ROLE, postData);
  yield takeLatest(actions.EDIT_ROLE, putData);
  yield takeLatest(actions.DELETE_ROLE, deleteData);

  //course subcontents

  yield takeLatest(actions.GET_COURSE_DOUBTS, fetchData);
  yield takeLatest(actions.GET_COURSE_DOUBT_COMMENTS, fetchData);
  yield takeLatest(actions.ADD_COURSE_DOUBT_COMMENTS, postData);
  yield takeLatest(actions.EDIT_COURSE_DOUBT_COMMENTS, putData);
  yield takeLatest(actions.DELETE_COURSE_DOUBT_COMMENTS, deleteData);
  yield takeLatest(actions.GET_COURSE_CLIENTS, fetchData);
  yield takeLatest(actions.GET_COURSE_FEEDBACKS, fetchData);
  yield takeLatest(actions.GET_COURSE_FEEDBACK_BY_ID, fetchData);

  // Rooms
  yield takeLatest(actions.GET_ROOM_INSTRUCTOR, fetchData);
  yield takeLatest(actions.GET_ROOM_INSTRUCTOR_BY_SLUG, fetchData);
  yield takeLatest(actions.ADD_ROOM_INSTRUCTOR, postData);
  yield takeLatest(actions.EDIT_ROOM_INSTRUCTOR, putData);
  yield takeLatest(actions.DELETE_ROOM_INSTRUCTOR, deleteData);

  // Announcement
  yield takeLatest(actions.GET_ANNOUNCEMENT_INSTRUCTOR, fetchData);
  yield takeLatest(actions.ADD_ANNOUNCEMENT_INSTRUCTOR, postData);
  yield takeLatest(actions.EDIT_ANNOUNCEMENT_INSTRUCTOR, putData);
  yield takeLatest(actions.DELETE_ANNOUNCEMENT_INSTRUCTOR, deleteData);

  // Room Frontend
  yield takeLatest(actions.GET_ROOM, fetchData);
  yield takeLatest(actions.GET_ROOM_DETAIL, fetchData);

  // Announcement Frontend
  yield takeLatest(actions.GET_ANNOUNCEMENT, fetchData);

  // Room Meetings
  yield takeLatest(actions.GET_ROOM_MEETINGS_INSTRUCTOR, fetchData);
  yield takeLatest(actions.ADD_ROOM_MEETINGS_INSTRUCTOR, postData);
  yield takeLatest(actions.EDIT_ROOM_MEETINGS_INSTRUCTOR, putData);
  yield takeLatest(actions.DELETE_ROOM_MEETINGS_INSTRUCTOR, deleteData);

  // Room Meetings Frontend
  yield takeLatest(actions.GET_ROOM_MEETINGS, fetchData);
  yield takeLatest(actions.GET_ROOM_MEETINGS_BY_SLUG, fetchData);

  // Room Discussions
  yield takeLatest(actions.GET_ROOM_DISCUSSION, fetchData);
  yield takeLatest(actions.GET_ROOM_DISCUSSION_BY_PAGE, fetchData);
  yield takeLatest(actions.ADD_ROOM_DISCUSSION, postData);
  yield takeLatest(actions.ROOM_DISCUSSION_LIKE, postData);
  yield takeLatest(actions.EDIT_ROOM_DISCUSSION, putData);
  yield takeLatest(actions.DELETE_ROOM_DISCUSSION, deleteData);

  // Room Discussion Comment
  yield takeLatest(actions.GET_ROOM_DISCUSSION_COMMENT, fetchData);
  yield takeLatest(actions.GET_ROOM_DISCUSSION_COMMENT_BY_PAGE, fetchData);
  yield takeLatest(actions.ADD_ROOM_DISCUSSION_COMMENT, postData);
  yield takeLatest(actions.ROOM_DISCUSSION_LIKE_COMMENT, postData);
  yield takeLatest(actions.ROOM_DISCUSSION_REPORT, postData);
  yield takeLatest(actions.EDIT_ROOM_DISCUSSION_COMMENT, putData);
  yield takeLatest(actions.DELETE_ROOM_DISCUSSION_COMMENT, deleteData);

  yield takeLatest(actions.RESPOND_GOING_TO_MEETING, postData);
  yield takeLatest(actions.JOIN_ROOM_REQUEST, postData);
  yield takeLatest(actions.RESPOND_TO_INVITATION_REQUEST, postData);
  yield takeLatest(actions.LEAVE_ROOM_REQUEST, postData);
  // Meetings Video
  yield takeLatest(actions.GET_MEETING_VIDEO, fetchData);
  yield takeLatest(actions.ADD_MEETING_VIDEO, postData);

  // Room Members
  yield takeLatest(actions.GET_ROOM_MEMBERS, fetchData);
  yield takeLatest(actions.UPDATE_ROOM_MEMBER, putData);
  yield takeLatest(actions.GET_ROOM_MEMBERS_BY_PAGE, fetchData);

  // Remove Room Members
  yield takeLatest(actions.REMOVE_ROOM_MEMBERS, postData);
  yield takeLatest(actions.INVITE_MEMBER_REQUEST, postData);
  yield takeLatest(actions.MIGRATE_COURSE_ENROLLED_USERS, postData);

  //Room assessment
  yield takeLatest(actions.GET_ASSESSMENT, fetchData);
  yield takeLatest(actions.GET_ASSESSMENT_BY_ID, fetchData);
  yield takeLatest(actions.ADD_ASSESSMENT, postData);
  yield takeLatest(actions.EDIT_ASSESSMENT, putData);
  yield takeLatest(actions.DELETE_ASSESSMENT, deleteData);
  yield takeLatest(actions.GET_ASSESSMENT_ANSWER, fetchData);
  yield takeLatest(actions.GET_ASSESSMENT_ANSWER_BY_ID, fetchData);
  yield takeLatest(actions.ADD_ASSESSMENT_ANSWER, postData);
  yield takeLatest(actions.EDIT_ASSESSMENT_ANSWER, putData);
  yield takeLatest(actions.DELETE_ASSESSMENT_ANSWER, deleteData);

  // Assessment Question
  yield takeLatest(actions.GET_ASSESSMENT_QUESTION_COMMENT, fetchData);
  yield takeLatest(actions.GET_ASSESSMENT_QUESTION_COMMENT_BY_PAGE, fetchData);
  yield takeLatest(actions.ADD_ASSESSMENT_QUESTION_COMMENT, postData);
  yield takeLatest(actions.EDIT_ASSESSMENT_QUESTION_COMMENT, putData);
  yield takeLatest(actions.DELETE_ASSESSMENT_QUESTION_COMMENT, deleteData);
  // AssessmentAnswer
  yield takeLatest(actions.GET_ASSESSMENT_ANSWER_COMMENT, fetchData);
  yield takeLatest(actions.GET_ASSESSMENT_ANSWER_COMMENT_BY_PAGE, fetchData);
  yield takeLatest(actions.ADD_ASSESSMENT_ANSWER_COMMENT, postData);
  yield takeLatest(actions.EDIT_ASSESSMENT_ANSWER_COMMENT, putData);
  yield takeLatest(actions.DELETE_ASSESSMENT_ANSWER_COMMENT, deleteData);
  // Class List
  yield takeLatest(actions.GET_LIVE_CLASS, fetchData);

  yield takeLatest(actions.GET_COURSE_LIVE_CLASS, fetchData);
  yield takeLatest(actions.ADD_COURSE_LIVE_CLASS, postData);
  yield takeLatest(actions.EDIT_COURSE_LIVE_CLASS, putData);
  yield takeLatest(actions.DELETE_COURSE_LIVE_CLASS, deleteData);

  // Get Mock test exam
  yield takeLatest(actions.GET_MOCK_TEST, fetchData);
  yield takeLatest(actions.GET_MOCK_TEST_COURSES, fetchData);
  yield takeLatest(actions.GET_MOCK_TEST_COURSES_BY_PAGE, fetchData);
  yield takeLatest(actions.GET_MOCK_TEST_REPORT, fetchData);

  // Submit Mock Test
  yield takeLatest(actions.SUBMIT_MOCK_TEST, postData);
  // Dropdowns
  yield takeLatest(actions.GET_USER_DROPDOWN, fetchData);
  yield takeLatest(actions.GET_COURSE_DROPDOWN, fetchData);
  yield takeLatest(actions.GET_SUBJECT_CONTENT_DROPDOWN, fetchData);

  // Payments
  yield takeLatest(actions.PAYMENT_REQUEST, postData);
  yield takeLatest(actions.PURCHASE_HISTORY_REQUEST, fetchData);

  // finance
  yield takeLatest(actions.GET_COUPON, fetchData);
  yield takeLatest(actions.ADD_COUPON, postData);
  yield takeLatest(actions.EDIT_COUPON, putData);
  yield takeLatest(actions.DELETE_COUPON, deleteData);

  // Verify
  yield takeLatest(actions.VOUCHER_VERIFY, postData);
  yield takeLatest(actions.USE_FREE_VOUCHER, postData);

  //email
  yield takeLatest(actions.SEND_COURSE_CLIENT_EMAIL, postData);
  // Extra
  yield takeLatest(actions.GET_WEBSITE_INFO, fetchData);

  //NOTES
  //notes course
  yield takeLatest(actions.GET_NOTES_COURSE_REQUEST, fetchData);
  yield takeLatest(actions.GET_NOTES_COURSE_BY_SLUG_REQUEST, fetchData);
  yield takeLatest(actions.ADD_NOTES_COURSE_REQUEST, postData);
  yield takeLatest(actions.EDIT_NOTES_COURSE_REQUEST, putData);
  yield takeLatest(actions.DELETE_NOTES_COURSE_REQUEST, deleteData);

  //notes subject
  yield takeLatest(actions.GET_NOTES_SUBJECT_REQUEST, fetchData);
  yield takeLatest(actions.GET_NOTES_SUBJECT_BY_SLUG_REQUEST, fetchData);
  yield takeLatest(actions.ADD_NOTES_SUBJECT_REQUEST, postData);
  yield takeLatest(actions.EDIT_NOTES_SUBJECT_REQUEST, putData);
  yield takeLatest(actions.DELETE_NOTES_SUBJECT_REQUEST, deleteData);

  //notes chapter
  yield takeLatest(actions.GET_NOTES_CHAPTER_REQUEST, fetchData);
  yield takeLatest(actions.GET_NOTES_CHAPTER_BY_SLUG_REQUEST, fetchData);
  yield takeLatest(actions.ADD_NOTES_CHAPTER_REQUEST, postData);
  yield takeLatest(actions.EDIT_NOTES_CHAPTER_REQUEST, putData);
  yield takeLatest(actions.DELETE_NOTES_CHAPTER_REQUEST, deleteData);

  //notes content
  yield takeLatest(actions.GET_NOTES_CONTENT_REQUEST, fetchData);
  yield takeLatest(actions.SEARCH_VIDEO, fetchData);
  yield takeLatest(actions.GET_NOTES_CONTENT_BY_SLUG_REQUEST, fetchData);
  yield takeLatest(actions.ADD_NOTES_CONTENT_REQUEST, postData);
  yield takeLatest(actions.EDIT_NOTES_CONTENT_REQUEST, putData);
  yield takeLatest(actions.DELETE_NOTES_CONTENT_REQUEST, deleteData);

  //notes category
  yield takeLatest(actions.GET_NOTES_CATEGORY_REQUEST, fetchData);
  yield takeLatest(actions.ADD_NOTES_CATEGORY_REQUEST, postData);
  yield takeLatest(actions.EDIT_NOTES_CATEGORY_REQUEST, putData);
  yield takeLatest(actions.DELETE_NOTES_CATEGORY_REQUEST, deleteData);

  //notes landing
  yield takeLatest(actions.GET_LANDING_NOTES_COURSE_REQUEST, fetchData);
  yield takeLatest(actions.GET_LANDING_NOTES_COURSE_BY_PAGE, fetchData);
  yield takeLatest(actions.GET_LANDING_NOTES_COURSE_DETAIL_REQUEST, fetchData);
  yield takeLatest(actions.GET_LANDING_NOTES_SUBJECT_DETAIL_REQUEST, fetchData);
}
